import { gql } from '@apollo/client';

const CONFIRM_ACTIONS = gql`mutation confirmActions(
	$supplierOrderId: Int!
	$performActions: [PerformActionInput]
) {
	incomingOrders {
		confirmActions(
			supplierOrderid: $supplierOrderId
			performActions: $performActions
		)
	}
}`;

export default CONFIRM_ACTIONS;